import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

/**
 * Inline confirmation dialog — replaces the native `window.confirm`
 * which can't be styled. Caller controls open/close state.
 *
 *   <ConfirmDialog
 *     open={confirming}
 *     title="Delete API key"
 *     message="Requests using this key will start returning 401."
 *     confirmLabel="Delete"
 *     confirmColor="error"
 *     onConfirm={doDelete}
 *     onCancel={() => setConfirming(false)}
 *   />
 */
export default function ConfirmDialog({
  open, title, message,
  confirmLabel = 'OK', cancelLabel = 'Cancel',
  confirmColor = 'primary',
  onConfirm, onCancel, busy,
}) {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth='xs' fullWidth>
      {title && <DialogTitle>{title}</DialogTitle>}
      {message && (
        <DialogContent>
          <DialogContentText>{message}</DialogContentText>
        </DialogContent>
      )}
      <DialogActions>
        <Button onClick={onCancel} disabled={busy}>{cancelLabel}</Button>
        <Button
          variant='contained'
          color={confirmColor}
          onClick={onConfirm}
          disabled={busy}
        >
          {busy ? 'Working…' : confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
